export const NOTIFICATIONS_POPOVER = {
    'NOTIFICATIONS.TOOLTIP.TITLE': 'Notificări'
};
